import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { ModeloVistoriaApiService } from '../editar-modelo-vistoria/services/modelo-vistoria-api.service';
import { ModeloVistoriaListItem } from '../editar-modelo-vistoria/models/modelo-vistoria-list-item';

@Injectable()
export class ListarModelosVistoriaResolver implements Resolve<ModeloVistoriaListItem[]> {

  constructor(
    private modeloVistoriaApiService: ModeloVistoriaApiService,
  ) { }

  resolve(): Observable<ModeloVistoriaListItem[]> {
    return this.modeloVistoriaApiService.listar();
  }
}
